import styled from "styled-components";

import { typography } from "utils/style";

const QuestionError = styled.div(
  typography({ color: "red", variant: "tidbit" }),
);

export default QuestionError;
